export type FailureCause =
  | "out-of-fuel"
  | "crashed"
  | "too-hot"
  | "no-control"
  | "no-parachute"
  | "tumbled";

export function explainFailure(cause: FailureCause): { title: string; message: string; hint: string } {
  switch (cause) {
    case "out-of-fuel":
      return {
        title: "Out of fuel",
        message:
          "Your rocket ran out of propellant before reaching a safe orbit or destination. Engines need fuel in the same stage to burn — check that the tank under your engine has propellant.",
        hint: "Try a bigger tank, or stage your boosters so they drop off when empty (less dead weight).",
      };
    case "crashed":
      return {
        title: "Impact!",
        message: "You hit the ground too fast. Anything faster than ~10 m/s usually means pieces fly.",
        hint: "Deploy a parachute below 900 m, or fire your engine to slow down before touchdown ('suicide burn').",
      };
    case "too-hot":
      return {
        title: "Burned up in the atmosphere",
        message:
          "Reentering too steep or too fast heats parts past what they can handle. The capsule's heat shield can take ~2400 K, but only pointed the right way.",
        hint: "Come in shallower (lower periapsis change) or use a larger heat-shielded part like the capsule.",
      };
    case "no-control":
      return {
        title: "No control",
        message: "Your rocket has no command pod or probe core, so nothing to steer with.",
        hint: "Add a Mk1 Capsule (with a pilot) or a Probe Core on top of the stack.",
      };
    case "no-parachute":
      return {
        title: "No parachute",
        message: "You tried to land a crew capsule without any way to slow down in the atmosphere.",
        hint: "Add a Parachute above the capsule before launch.",
      };
    case "tumbled":
      return {
        title: "Lost control — tumbling",
        message: "The rocket spun out. Long rockets with lots of top-heavy mass and no fins are unstable in the atmosphere.",
        hint: "Add Control Fins low on the rocket, or reduce top-heavy mass.",
      };
  }
}
